import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
interface ConceptCardProps {
  title: string;
  description?: string;
  gradientClass: string;
  imageUrl?: string;
  href?: string;
  delay?: number;
}
export function ConceptCard({
  title,
  description,
  gradientClass,
  imageUrl,
  href = '/concepts',
  delay = 0
}: ConceptCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6,
    delay
  }} className="group relative h-96 w-full overflow-hidden rounded-sm" data-id="element-356">
      <Link to={href} className="block w-full h-full" data-id="element-357">
        {/* Image or Gradient Background */}
        {imageUrl ? <img src={imageUrl} alt={title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-358" /> : <div className={`absolute inset-0 ${gradientClass} opacity-90 transition-transform duration-700 group-hover:scale-105`} data-id="element-359" />}

        {/* Subtle texture overlay */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIiBmaWxsLW9wYWNpdHk9IjAuMDUiLz4KPC9zdmc+')] opacity-20 mix-blend-overlay" data-id="element-360" />

        {/* Content */}
        <div className="absolute inset-0 p-8 flex flex-col justify-end bg-gradient-to-t from-brand-green-deep/90 via-brand-green-deep/40 to-transparent" data-id="element-361">
          <div className="transform transition-transform duration-500 translate-y-4 group-hover:translate-y-0" data-id="element-362">
            <h3 className="text-2xl font-heading text-brand-cream-light mb-2" data-id="element-363">
              {title}
            </h3>

            <div className="opacity-0 h-0 overflow-hidden transition-all duration-500 group-hover:opacity-100 group-hover:h-auto group-hover:mt-3" data-id="element-364">
              {description && <p className="text-brand-cream/80 font-body text-sm mb-4 line-clamp-2" data-id="element-365">
                  {description}
                </p>}
              <span className="inline-flex items-center text-brand-gold text-sm font-medium uppercase tracking-wider" data-id="element-366">
                Explore <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-367" />
              </span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>;
}